import Component from '../Component';
import { fadeOut, fadeIn } from '@siteparts/show-hide-effects';

class ControlButtonGroup extends Component {
	constructor(props) {
		super(props);
		this.key = this.props.render.getKey();
	}

	componentDidMount() {
		this.props.render.setRefs(this.refs);
		this.props.render.componentDidMount();
	}

	hide() {
		fadeOut(this.component);
	}

	show() {
		fadeIn(this.component);
	}

	render() {
		return `
            <div ref="component-${this.key}" class="control-button-group ${this.props.render.getClassName()}">
                ${this.props.render.render()}
            </div>`;
	}
}

export default ControlButtonGroup;
